import { useState } from "react";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { componentStyles } from "./product-card.scss";
import PictureComponent from "/components/core/picture/picture-component";
import Colors from "/styles/colors";
import Tag from "./tag/tag";
import ViSign from "/static/svg/vi_icon.svg";
import {
  FIRST_FOLD_PRODUCT_CARD_HOVERED,
  PRODUCT_CARD_SELECTED,
  PRODUCT_CARD_UNSELECTED,
  CHECKBOX_SELECTED,
  CHECKBOX_UNSELECTED
} from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import classnames from "classnames";
import Title from "segments/desktop/core-components/title/title";
import { XS_M } from "constants/sizes";

function ProductCard(props) {
  const { product, setSelectedProductColors, handleCardClick, index, translate } = props;
  const {
    productType,
    text,
    productImage,
    logoImage,
    backgroundColor,
    departments,
    useCases,
    cardMainColor,
    useCasesTagesTextColor,
    useCasesTagsBackgroundColor
  } = product;
  const [isHovered, setIsHovered] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleMouseEnter = () => {
    trackEvent(FIRST_FOLD_PRODUCT_CARD_HOVERED, { kind: productType });
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    setIsChecked(!isChecked);
    setIsClicked(true);
    handleCardClick(productType);
    setTimeout(() => setIsClicked(false), 300);

    if (!isChecked) {
      trackEvent(PRODUCT_CARD_SELECTED, { kind: productType });
    } else {
      trackEvent(PRODUCT_CARD_UNSELECTED, { kind: productType });
    }

    setSelectedProductColors((colors) => {
      const newColors = [...colors];
      if (isChecked) {
        newColors[index] = null;
      } else {
        newColors[index] = Colors[cardMainColor];
      }
      return newColors;
    });
  };

  const handleCheckboxClick = () => {
    if (!isChecked) {
      trackEvent(CHECKBOX_SELECTED, { kind: productType });
    } else {
      trackEvent(CHECKBOX_UNSELECTED, { kind: productType });
    }
  };

  return (
    <div
      className={classnames("home-page-product-card", {
        hover: isHovered,
        checked: isChecked,
        clicked: isClicked
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      style={{
        backgroundColor: Colors[backgroundColor],
        borderColor: isChecked ? Colors[cardMainColor] : Colors.gainsboro
      }}
    >
      <div
        role="checkbox"
        aria-checked={isChecked}
        className={classnames("card-checkbox", { checked: isChecked })}
        onClick={handleCheckboxClick}
        style={{
          borderColor: Colors[cardMainColor],
          backgroundColor: isChecked ? Colors[cardMainColor] : Colors[WHITE_COLOR_NAME]
        }}
      >
        <div className="vi-sign-wrapper">
          <ViSign />
        </div>
      </div>

      <div className="card-top-part">
        <div className="logo-image-wrapper">
          <PictureComponent src={logoImage} />
        </div>
        <div className="card-text">{text}</div>
        <div className="card-departments">
          {departments?.map((department, index) => (
            <Tag key={index} {...department} cardMainColor={cardMainColor} />
          ))}
        </div>
      </div>
      <div className="card-image-wrapper">
        <PictureComponent src={productImage} />
      </div>

      <div
        className={classnames("card-back", { up: isHovered, down: !isHovered })}
        style={{ backgroundColor: Colors[backgroundColor] }}
      >
        <div className="title-wrapper">
          <Title title={translate("firstFoldWithProducts.Card.topUseCases")} titleSize={XS_M} />
        </div>
        <div className="card-use-cases">
          {useCases?.map((useCase, index) => (
            <Tag
              key={index}
              {...useCase}
              invertColors={true}
              useCasesTagesTextColor={useCasesTagesTextColor}
              useCasesTagsBackgroundColor={useCasesTagsBackgroundColor}
            />
          ))}
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
}

export default ProductCard;
